"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverGlobalStyleMixin = void 0;
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _ModalGlobalStyleMixin = require("./ModalGlobalStyleMixin");
/** @class PopoverGlobalStyleMixin */
/** @method */
var PopoverGlobalStyleMixin = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('modal', function (mediaProps) {
  if (mediaProps.modal) {
    return (0, _ModalGlobalStyleMixin.ModalGlobalStyleMixin)(mediaProps);
  }
  return '';
});
exports.PopoverGlobalStyleMixin = PopoverGlobalStyleMixin;